import React from 'react'
import MarketingImage from './MarketingImage'
import Icon from '../components/Icon'

const MarketingOne = ({ services }) => {
  const whichService = 'marketKitchen'

  return (
    <div className="relative flex flex-col flex-1 overflow-hidden md:flex-row lg:flex-col">
      {services.some(service => service.name === whichService) ? (
        <a
          href="https://my.morrisons.com/market-kitchen/"
          target="_blank"
          rel="noreferrer"
          className="flex flex-1"
        >
          <MarketingImage
            name="marketkitchen"
            alt="Morrisons Market Kitchen"
            className="block w-full"
          />
        </a>
      ) : (
        <a
          href="https://my.morrisons.com/foodtoorder/"
          target="_blank"
          rel="noreferrer"
          className="relative flex justify-start flex-1 aspect-ratio-4/3 sm:aspect-ratio-21/9 lg:aspect-ratio-4/3"
        >
          <MarketingImage
            name="foodtoorder"
            alt="Morrisons Food To Order"
            className="z-0 block object-cover w-full h-full sm:w-1/2 lg:w-full"
            style={{ position: 'absolute' }}
          />
          <div className="absolute bottom-0 right-0 z-10 flex flex-col w-full p-4 lg:pt-3 xl:pt-4 sm:h-full sm:w-1/2 lg:w-full bg-secondary lg:h-auto">
            <div className="mb-2">
              <h4 className="text-xl font-semibold leading-none text-white">
                Morrisons Food To Order
              </h4>
            </div>
            <div className="flex-1 mb-3">
              <p className="text-base font-semibold leading-tight text-white md:text-sm xl:text-base">
                Make the most of your occasion, big or small, with our selection
                of great value Food to Order.
              </p>
            </div>
            <span className="flex items-center justify-end text-white">
              <span className="pr-2 font-semibold leading-tight whitespace-nowrap">
                Find Out More
              </span>
              <Icon icon="forwardArrow" className="fill-current" />
            </span>
          </div>
        </a>
      )}
    </div>
  )
}

export default MarketingOne
